import { Routes, Route, useLocation } from "react-router-dom";
import { Suspense, lazy } from "react";
import { useTranslation } from "react-i18next";

import Sidebar from "./layouts/Siderbar";
import Login from "./layouts/Login";
import ChangePassword from "./layouts/password/ChangePasswordFirstLogin"
import RoleRedirect from "./components/RoleRedirect";
import ProtectedRoute from "./components/ProtectedRoute";
import ForgotPassword from "./layouts/password/ForgotPassword";
import ResetPassword from "./layouts/password/ResetPasswordFotgot";

// Importamos los routers por rol
import AdminRoutes from "./router/admin.router";
import SupervisorRoutes from "./router/supervisor.router";
import DirectorRoutes from "./router/director.router";
import OperatorRoutes from "./router/operator.router";
import SharedRoutes from "./router/shared.router";

const Configuration = lazy(() => import("./layouts/Configuration"));

function App() {
  const location = useLocation();
  const hideSidebar = location.pathname === "/login" ||
    location.pathname === "/change-password" ||
    location.pathname === "/forgot-password" ||
    location.pathname === "/reset-password";
  const { t } = useTranslation();

  return (
    <div className="flex">
      {/* Sidebar fijo */}
      {!hideSidebar && (
        <aside className="fixed left-0 top-0 w-64 h-screen">
          <Sidebar />
        </aside>
      )}

      {/* Main adaptado */}
      <main
        className={`flex-1 transition-all ${
          hideSidebar ? "" : "ml-64"
        }`}
      >
        <Suspense fallback={<div className="p-4">{t("loading", "Cargando...")}</div>}>
          <Routes>
            {/* Rutas púlicas - Login + Change password */}
            <Route path="/login" element={<Login />} />
            <Route path="/change-password" element={<ChangePassword />}/>
            <Route path="/forgot-password" element={<ForgotPassword />}/>
            <Route path="/reset-password" element={<ResetPassword />}/>

            {/* Rutas compartidas (token interno) */}
            {SharedRoutes()}

            {/* Rutas modulares */}
            {AdminRoutes()}
            {SupervisorRoutes()}
            {DirectorRoutes()}
            {OperatorRoutes()}

            <Route
              path="/configuration"
              element={
                <ProtectedRoute>
                  <Configuration />
                </ProtectedRoute>
              }
            />

            {/* Redirección al dashboard según rol */}
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <RoleRedirect />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Suspense>
      </main>
    </div>
  );
}

export default App;
